module.exports = __webpack_public_path__ + "static/isolation_timeline-cdd41bf7790ecfc8c4172978f445ce43.png";